// appCreationReducer.js
import {
  SET_SELECTED_FRAMEWORK,
  SET_CHAT_APP_NAME,
  SET_SELECTED_APP_TYPE,
  SET_THEME_SETTINGS,
  SET_SELECTED_KEY,
  SET_BOT_CONTENT,
  RESET_APP_CREATION
} from "../allAction/appCreationActions";

const default_chat_settings = {
  redirect_uri: "/",
  theme: {
    chat_opener_theme: {
      textColor: "#ffffff",
      backgroundColor: "#a370ce",
    },
    header_theme: {
      textColor: "#ffffff",
      backgroundColor: "#d00135",
    },
    chat_box_theme: {
      textColor: "#ffffff",
      backgroundColor: "#008000",
    },
  },
};

// Default bot content structure - matches the botContent pattern
const defaultBotContent = {
  FAQ: {
    uuid: 'q_default',
    type: 'Multiple Choice',
    statement: "",
    answers: [],
    subQuestions: [],
    inputType: 'string'
  },
  WELCOME_MSG: "", // Keep for backward compatibility
  OFFLINE_MSG: "", // Keep for backward compatibility
  enabled_bot_content: false,
  ai_agent_bot_enabled: false,
  live_agent_enabled: false,
  session_enabled: false,
  dont_show_chat_box_at_logout: false,
  exclude_paths: [],
  
  // ADD: live_settings structure
  live_settings: {
    WELCOME_MSG: "",
    OFFLINE_MSG: ""
  },

  ingestion_methods: {
    files: [],
    urls: [],
    sitemap: null
  },
  allow_nested: true,
  kb_id: null
};

const initialState = {
  selectedFramework: "",
  chatAppName: "",
  selectedAppType: "P2A",
  themeSettings: default_chat_settings,
  selectedKey: "Choose_Framework_Type",
  botContent: defaultBotContent, // Single source of truth for bot content
};

export const appCreationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_FRAMEWORK:
      return { ...state, selectedFramework: action.payload };

    case SET_CHAT_APP_NAME:
      return { ...state, chatAppName: action.payload };

    case SET_SELECTED_APP_TYPE:
      return { ...state, selectedAppType: action.payload };

    case SET_THEME_SETTINGS:
      return { ...state, themeSettings: action.payload };

    case SET_SELECTED_KEY:
      return { ...state, selectedKey: action.payload };

    case SET_BOT_CONTENT:
      return {
        ...state,
        botContent: typeof action.payload === 'function'
          ? action.payload(state.botContent)
          : action.payload
      };

    case RESET_APP_CREATION:
      return initialState;

    default:
      return state;
  }
};